<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">

    <!--begin::sidebar-->
    <sidebar-component classMenu="poolTransactions"></sidebar-component>
    <!--end::sidebar-->



    <div class="page-wrapper">
    <!--begin::navbar-->
    <navbar-component></navbar-component>
    <!--end::navbar-->

    <!--begin::content-->
    <div class="page-content">
        
        <div class="row">
          <div class="col-12 grid-margin">
            <div class="card">

                <div class="position-relative">
                    <div v-if="this.transactionData.permit_status == 'APPROVED'" style="text-align: center; width: 100%; height: 100%; position: absolute; left: 0; top: 100px; z-index: 20;">
                        <img src="/assets/icon/approved.png" class="rounded-top" style="max-width: 10%;">
                    </div>
                    <div v-else style="text-align: center; width: 100%; height: 100%; position: absolute; left: 0; top: 100px; z-index: 20;">
                        <img src="/assets/icon/denied.png" class="rounded-top" style="max-width: 10%;">
                    </div>
                    <figure class="overflow-hidden mb-0 d-flex justify-content-center">
                        <img src="https://via.placeholder.com/1560x370" class="rounded-top" alt="">
                    </figure>
                    
                    <div class="d-flex justify-content-between align-items-center position-absolute top-90 w-100 px-2 px-md-4 mt-n4" style="padding-left: 2.5rem !important;margin-top: -4.5rem !important;">
                    <div>
                        <div v-if="this.driverData.photo">
                            <img class="wd-100 rounded-circle" :src="this.driverData.photo" alt="">
                        </div>
                        <div v-else>
                            <img class="wd-100 rounded-circle" src="/assets/icon/no-image.png">
                        </div>
                    </div>
                    
                    </div>

                </div>

                <div class="d-flex justify-content-left p-3 rounded-bottom">
                    <ul class="d-flex align-items-center m-0 p-0">
                        <li class="d-flex align-items-center active">
                            {{$t('driver_name')}} : {{this.transactionData.driver_name}} - {{this.transactionData.driver_nmk}}
                        </li>
                        <li class="ms-3 ps-3 border-start d-flex align-items-center">
                            {{$t('handphone')}} : {{this.transactionData.driver_hp}}
                        </li>
                        <li class="ms-3 ps-3 border-start d-flex align-items-center">
                            {{$t('sim')}} : {{this.getSimData()}}
                        </li>
                    
                    </ul>
                    
                </div>

                 <div class="d-flex justify-content-left p-3 rounded-bottom">
                    <ul class="d-flex align-items-center m-0 p-0">
                        <li class="d-flex align-items-center active">
                            {{$t('transaction_date')}} : {{this.transactionData.transaction_date}}
                        </li>
                        <li class="ms-3 ps-3 border-start d-flex align-items-center">
                            {{$t('statusTxt')}} :&nbsp;<div v-if="this.transactionData.status == 'IN'" style="background-color: greenyellow;"><b>{{$t('in_to_pool')}}</b></div>
                            <div v-else style="background-color: red;"><b>{{$t('exit_from_pool')}}</b></div>
                        </li>
                        <li class="ms-3 ps-3 border-start d-flex align-items-center">
                             <button
                             @click="$router.back()"
                            class="btn btn-warning float-end"
                            type="button">
                            <i class="link-icon" data-feather="arrow-left"></i>
                            {{ $t("backMess") }}
                            </button> 
                        </li>
                    
                    </ul>
                </div>

                
            </div>
          </div>
        </div>


        <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
            <div class="card">
                <div class="card-body">

                    <div class="row mb-3">



                        <div class="col-lg-3">
                        

                            <div class="table-responsive">
                                <table class="table">
                                    <tr>
                                    <td>
                                        <table class="table" border="1">
                                            <tr>
                                                <td v-if="this.truckData.images" :background="this.truckData.images" style="background-repeat: no-repeat;background-size: 100%;" width="100px" height="150px">
                                                    
                                                </td>
                                                <td v-else background="/assets/icon/no-image.png" style="background-repeat: no-repeat;background-size: 100%;" width="100px" height="150px">
                                                    
                                                </td>
                                                <td>
                                                    <h5 style="top: 25%;">
                                                    {{$t('vehicle_no')}}
                                                    <br>
                                                    {{this.transactionData.vehicle_no}}
                                                    <br>
                                                    {{$t('truck_type')}}
                                                    <br>
                                                    {{this.transactionData.vehicle_type}}
                                                    </h5>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="2">

                                                    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12">
                                                        {{$t('stnk')}} <br>
                                                        {{this.getStnkData()}}
                                                    </div>

                                                    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12">
                                                        {{$t('kir')}} <br>
                                                        {{this.getKirData()}}
                                                    </div>

                                                    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12">
                                                        {{$t('km_real')}} <br>
                                                        {{this.transactionData.km_real}}
                                                    </div>

                                                    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12">
                                                        {{$t('km_gps')}} <br>
                                                        {{this.transactionData.km_gps}}
                                                    </div>

                                                    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12">
                                                        {{$t('km_service')}} <br>
                                                        {{this.transactionData.km_service}}
                                                    </div>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="2">

                                                    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12">
                                                        {{$t('status_remarks')}} <br>
                                                        {{this.transactionData.keterangan}}
                                                    </div> 

                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    </tr>

                                </table>
                            </div>

                        </div>

                        <div class="col-lg-9">


                           
                                <div class="table-responsive">
                                <table class="table">

                                    <tr>
                                        <td>
                                            <table class="table" border="1">
                                                <tr>
                                                    <td>
                                                        {{$t('load_id')}} :  {{this.blujayData.load_id}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        {{$t('load_group')}} :  {{this.blujayData.load_group}}
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                             <br>
                                             
                                            <h6 class="card-title">{{$t('detail_transport_order_txt')}}</h6>
                                          
                                             <div style="height: 200px;overflow: scroll;">

                                                <table class="table" border="1">
                                                    <tr>
                                                        <td>{{$t('nomor')}}</td>
                                                        <td>{{$t('shipment_number')}}</td>
                                                        <td>{{$t('customer')}}</td>
                                                        <td>{{$t('route')}}</td>
                                                        <td>{{$t('muatan')}}</td>
                                                    </tr> 
                                                    <tr v-for="(detail, index) in this.blujayData.order_detail" :key="detail.order_detail_id" :value="detail.order_detail_id">

                                                    <td>{{index+1}}</td>
                                                    <td>{{detail.order_number}}</td>
                                                    <td>{{detail.customer_name}}</td>
                                                    <td>{{detail.name_rute}}</td>
                                                    <td>{{detail.product_type}}</td>

                                                </tr>
                                                    
                                                </table>

                                             </div>
                                        </td>
                                    </tr>



                                    <tr>
                                        <td>
                                             <br>
                                             
                                            <h6 class="card-title">{{$t('equipment')}}</h6>

                                            <table class="table" border="1">
                                                <tr>
                                                    <td width="25px">
                                                        {{$t('dongkrak')}} 
                                                    </td>
                                                    <td width="2px">
                                                        :
                                                    </td>
                                                    <td width="2px">
                                                       <div v-if="this.transactionData.dongkrak == 'Ada'" style="background-color: green;"><b style="color:white;">{{this.transactionData.dongkrak}}</b></div><div v-else style="background-color: red;"><b style="color:white;">{{this.transactionData.dongkrak}}</b></div>
                                                    </td>
                                                    <td width="25px">
                                                         
                                                    </td>
                                                    <td width="25px">
                                                        {{$t('kunci_roda')}} 
                                                    </td>
                                                    <td width="2px">
                                                        :
                                                    </td>
                                                    <td width="2px">
                                                       <div v-if="this.transactionData.kunci_roda == 'Ada'" style="background-color: green;"><b style="color:white;">{{this.transactionData.kunci_roda}}</b></div><div v-else style="background-color: red;"><b style="color:white;">{{this.transactionData.kunci_roda}}</b></div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="25px">
                                                        {{$t('spion_kanan')}} 
                                                    </td>
                                                    <td width="2px">
                                                        :
                                                    </td>
                                                    <td width="2px">
                                                       <div v-if="this.transactionData.spion_kanan == 'Ada'" style="background-color: green;"><b style="color:white;">{{this.transactionData.spion_kanan}}</b></div><div v-else style="background-color: red;"><b style="color:white;">{{this.transactionData.spion_kanan}}</b></div>
                                                    </td>
                                                    <td width="25px">
                                                         
                                                    </td>
                                                    <td width="25px">
                                                        {{$t('spion_kiri')}} 
                                                    </td>
                                                    <td width="2px">
                                                        :
                                                    </td>
                                                    <td width="2px">
                                                       <div v-if="this.transactionData.spion_kiri == 'Ada'" style="background-color: green;"><b style="color:white;">{{this.transactionData.spion_kiri}}</b></div><div v-else style="background-color: red;"><b style="color:white;">{{this.transactionData.spion_kiri}}</b></div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="25px">
                                                        {{$t('ban_stip')}} 
                                                    </td>
                                                    <td width="2px">
                                                        :
                                                    </td>
                                                    <td width="2px">
                                                       <div v-if="this.transactionData.ban_stip == 'Ada'" style="background-color: green;"><b style="color:white;">{{this.transactionData.ban_stip}}</b></div><div v-else style="background-color: red;"><b style="color:white;">{{this.transactionData.ban_stip}}</b></div>
                                                    </td>
                                                    <td width="25px">
                                                         
                                                    </td>
                                                    <td width="25px">
                                                        {{$t('kotak_p3k')}} 
                                                    </td>
                                                    <td width="2px">
                                                        :
                                                    </td>
                                                    <td width="2px">
                                                       <div v-if="this.transactionData.kotak_p3k == 'Ada'" style="background-color: green;"><b style="color:white;">{{this.transactionData.kotak_p3k}}</b></div><div v-else style="background-color: red;"><b style="color:white;">{{this.transactionData.kotak_p3k}}</b></div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="25px">
                                                        {{$t('ban_serep')}} 
                                                    </td>
                                                    <td width="2px">
                                                        :
                                                    </td>
                                                    <td width="2px">
                                                       <div v-if="this.transactionData.ban_serep == 'Ada'" style="background-color: green;"><b style="color:white;">{{this.transactionData.ban_serep}}</b></div><div v-else style="background-color: red;"><b style="color:white;">{{this.transactionData.ban_serep}}</b></div>
                                                    </td>
                                                    <td width="25px">
                                                         
                                                    </td>
                                                    <td width="25px">
                                                        {{$t('radio_tape')}} 
                                                    </td>
                                                    <td width="2px">
                                                        :
                                                    </td>
                                                    <td width="2px">
                                                       <div v-if="this.transactionData.radio_tape == 'Ada'" style="background-color: green;"><b style="color:white;">{{this.transactionData.radio_tape}}</b></div><div v-else style="background-color: red;"><b style="color:white;">{{this.transactionData.radio_tape}}</b></div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="25px">
                                                        {{$t('speedometer')}} 
                                                    </td>
                                                    <td width="2px">
                                                        :
                                                    </td>
                                                    <td width="2px">
                                                       <div v-if="this.transactionData.speedometer == 'Ada'" style="background-color: green;"><b style="color:white;">{{this.transactionData.speedometer}}</b></div><div v-else style="background-color: red;"><b style="color:white;">{{this.transactionData.speedometer}}</b></div>
                                                    </td>
                                                    <td width="25px">
                                                         
                                                    </td>
                                                    <td width="25px">
                                                        
                                                        
                                                    </td>
                                                    <td width="2px">
                                                      
                                                      
                                                    </td>
                                                    <td width="2px">

                                                     </td>
                                                </tr>
                                                 
                                            </table>
                                        </td>
                                    </tr>

                                </table>
                                </div>
 


                        </div>

                    </div>

                </div>
            </div>
        </div>
        
    </div>
    <!--end::content-->

    <!--begin::footer-->
    <footer-component></footer-component>
    <!--end::footer-->

      </div>
    </div>
  </div>
</template>


<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import moment from "moment";
export default {
    name: "poolTransactions",
    props: {},
    components: {
        "sidebar-component": sidebarComponent,
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
  
    },
    data() {
        return {
            permision_role: [],
            isLoading: false,
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            errors: [],
            userData: "",
            driverData:{},
            truckData:{},
            blujayData:{},
            transactionData:""
        }
    },
    computed: {

    },
    watch: {},
    methods: {
        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'GateTransactionController') {
                rolePermision = permision;
                // console.log(permision);
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;

        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });

            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        loadData() {
            var paramId = this.$onBehind(this.$route.params.id);
            this.isLoading = true;
            var baseURI = this.$settings.endPointGT + "gate-transaction/detail/" + paramId;
    
            return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
 
            this.transactionData = response.data.datas
            this.loadDriver()
            this.loadTruck()
            this.loadBlujay()
            this.isLoading = false;
            }).catch(error => {
                this.isLoading = false;
                if(error.code == "ECONNABORTED"){
                    this.error(this.$t("check_internet_connection_txt"));
                }else{

                    if (error.response) {
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        }else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        }else if (error.response.status === 401) {
                            this.$router.push('/authorized-error');
                        }else{
                            this.$router.push('/page-not-found');
                        }
                    }

                }

            });
        },

        getSimData(){
            
            const status_surat_detail = this.transactionData.status_surat_detail

            if(status_surat_detail?.length > 0){
                var responseData = ""
                status_surat_detail.forEach(function (dstnk) {
                    if (dstnk.nama_surat == 'KIR') {
                        const date_of_expire = moment(dstnk.date_of_expire).format("DD/MM/YYYY");
                        responseData = `(${dstnk.status}) - ${date_of_expire}`
                    }
                });
                return responseData
            }else{
                return ""
            }


        },

        getStnkData(){

            
            const status_surat_detail = this.transactionData.status_surat_detail

            if(status_surat_detail?.length > 0){
                var responseData = ""
                status_surat_detail.forEach(function (dstnk) {
                    if (dstnk.nama_surat == 'STNK') {
                        const date_of_expire = moment(dstnk.date_of_expire).format("DD/MM/YYYY");
                        responseData = `(${dstnk.status}) - ${date_of_expire}`
                    }
                });
                return responseData
            }else{
                return ""
            }
        },

        getKirData(){

            
            const status_surat_detail = this.transactionData.status_surat_detail

            if(status_surat_detail?.length > 0){
                var responseData = ""
                status_surat_detail.forEach(function (dstnk) {
                    if (dstnk.nama_surat == 'KIR') {
                        const date_of_expire = moment(dstnk.date_of_expire).format("DD/MM/YYYY");
                        responseData = `(${dstnk.status}) - ${date_of_expire}`
                    }
                });
                return responseData
            }else{
                return ""
            }
        },

        loadDriver() {
          
           
            var baseURI = this.$settings.endPointCt + "master-driver/detail/" + this.transactionData.master_driver_id;
            return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
 
                this.driverData = response.data.datas
                 
            })

        },

        loadTruck() {
          
           
            var baseURI = this.$settings.endPointCt + "master-truck/detail/" + this.transactionData.master_truck_id;
            return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
 
                this.truckData = response.data.datas
                 
            })

        },

        loadBlujay(){
 
            var baseURI = this.$settings.endPointCt + "blujay-order/checkdata-vehicle-no/" + this.transactionData.vehicle_no;
            return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
 
                this.blujayData = response.data.datas
                 
            })

        },

    },
    events: {},
    created: function () { },
    mounted() {
        this.loadData();
        this.fetchIt();

    }

}

</script>
<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}
.blur-content{
  filter: blur(5px); 
}
</style>